// extracted by mini-css-extract-plugin
export default {"selectWords":"SelectWords_selectWords__2M7Nh","container":"SelectWords_container__unsCI"};